<template>
  <div class="service-nav">
    <a
      id="services"
      class="nav-link"
      @click="toggleServicesMenu"
    >Services <i class="icon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="17.79"
        height="11.844"
        viewBox="0 0 17.79 11.844"
      ><path
        d="M7.5,21.214.367,14.076a1.254,1.254,0,0,1,0-1.779L1.553,11.11a1.254,1.254,0,0,1,
              1.779,0l5.06,5.06,5.06-5.06a1.254,1.254,0,0,1,1.779,0L16.417,12.3a1.254,1.254,0,0,1,
              0,1.779L9.279,21.214a1.248,1.248,0,0,1-1.774,0Z"
        transform="translate(0.504 -10.24)"
      /></svg>
    </i>
    </a>
    <div
      id="services-menu"
      class="menu-dropdown hidden"
    >
      <ul class="dropdown-list">
        <li
          v-for="subItem in serviceItems[0].sub_items"
          :key="subItem.name"
          class="dropdown-item"
        >
          <router-link
            :to="subItem.link"
            class="dropdown-link"
          >
            {{ subItem.name }}
          </router-link>
        </li>
        <div class="button-container">
          <router-link
            to="/service"
            class="secondary-button"
          >
            See Full services 🡢
          </router-link>
        </div>
      </ul>
    </div>
  </div>
</template>
<script setup>
import {computed, onMounted, ref} from 'vue'
import {useServiceStore} from '@/store'

const serviceStore = useServiceStore()

const topServices = computed(() => serviceStore.getThreeServices)

const serviceLinks = topServices.value.map((val)=>({name: val.title, link: `/service?id=${val.id}`}))

const serviceItems = ref([
    {name: 'Services', link: '/service', sub_items: [
      ...serviceLinks,
    ]},
    ])

    const toggleServicesMenu = () => {
      let menu = document.querySelector('#services-menu')
      let services = document.querySelector('#services')

      if (menu?.classList.contains('hidden')) {
        menu.classList.remove('hidden')
        services?.classList.add('active')
      } else {
        menu?.classList.add('hidden')
        services?.classList.remove('active')
      }
    }
</script>
